<img
	src="./assets/img/{{name}}.{{format}}"
	[style.width.px]="width"
	[style.height.px]="height"
	(mouseenter)="onMouseEnter()"
	(mouseleave)="onMouseLeave()"
/>
